import { render, staticRenderFns } from "./addQuestion.vue?vue&type=template&id=54ff8e82&scoped=true&"
import script from "./addQuestion.vue?vue&type=script&lang=js&"
export * from "./addQuestion.vue?vue&type=script&lang=js&"
import style0 from "./addQuestion.vue?vue&type=style&index=0&id=54ff8e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ff8e82",
  null
  
)

export default component.exports